import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export default function EmptyState({ title, description, onGenerate, generating, progressMessage, isReadOnly }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: 200,
      p: 4,
      bgcolor: '#f8fafc',
      borderRadius: 2,
      border: '2px dashed #cbd5e1'
    }}>
      {generating ? (
        <>
          <CircularProgress sx={{ mb: 2, color: '#7c3aed' }} />
          <Typography variant="body1" sx={{ fontWeight: 600, color: '#7c3aed', mb: 1 }}>
            Generating...
          </Typography>
          {progressMessage && (
            <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
              {progressMessage}
            </Typography>
          )}
        </>
      ) : (
        <>
          <AutoAwesomeIcon sx={{ fontSize: 48, color: '#94a3b8', mb: 2 }} />
          <Typography variant="h6" sx={{ mb: 1, color: '#475569', fontWeight: 600 }}>
            {title || 'No Content Generated'}
          </Typography>
          <Typography variant="body2" sx={{ mb: 3, color: '#64748b', textAlign: 'center', maxWidth: 400 }}>
            {description || 'Click the button below to generate AI-powered content for this module.'}
          </Typography>
          {onGenerate && !isReadOnly && (
            <Button 
              variant="contained" 
              startIcon={<AutoAwesomeIcon />}
              onClick={onGenerate}
              disabled={generating}
              sx={{ 
                bgcolor: '#7c3aed', 
                '&:hover': { bgcolor: '#6d28d9' },
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Generate Content
            </Button>
          )}
        </>
      )}
    </Box>
  );
}

